var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v10H0V3h12v2H2v15h17v-8zm3-12H13.012l4.035 4-6.977 7.07 2.83 2.83 6.977-7.07L24 11z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDI0IDIyIj48cGF0aCBkPSJNMjEsMTNWMjNIMFY0SDEyVjZIMlYyMUgxOVYxM1pNMjQsMUgxMy4wMTJsNC4wMzUsNEwxMC4wNywxMi4wNywxMi45LDE0LjlsNi45NzctNy4wN0wyNCwxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEpIiBmaWxsPSIjZmZmIi8+PC9zdmc+";
export { SvgExLink as ReactComponent };